/** A KPI group tile's narrowest width before the group wraps. */
export const kBiKpiTileMinPx = 140;
/** The gap between a KPI group's tiles and between its rows. */
export const kBiKpiGapPx = 12;

/**
 * How many tiles each row of a KPI group holds at `width`: as few rows as
 * the narrowest tile allows, filled evenly with the longer rows first, so
 * four tiles that fit three go 2 + 2 and seven go 3 + 2 + 2.
 */
export function biKpiGroupLines(
  count: number,
  width: number,
  gap: number,
  minTile: number,
): number[] {
  if (count <= 0) return [];
  const fits = Math.max(1, Math.floor((width + gap) / (minTile + gap)));
  const rows = Math.ceil(count / Math.min(count, fits));
  const base = Math.floor(count / rows);
  const extra = count % rows;
  return Array.from({ length: rows }, (_, row) => base + (row < extra ? 1 : 0));
}
